module.exports = __webpack_public_path__ + "img/last-track-button.c045b347.svg";